import React from 'react'
import {
  FirebaseMessageListItem,
  MessageFilterOlder,
  MessageMode,
  ObjectState,
} from 'types'
import GiftShopMessageListHome from './GiftShopMessageListHome'
import GiftShopMessageListNew from './GiftShopMessageListNew'

export interface GiftShopMessageListProps {
  stateMode: ObjectState<MessageMode>
  stateSelectedMessagesForkygram: ObjectState<string[]>
  stateSelectedMessagesGS: ObjectState<string[]>
  stateSelectedMessagesSystem: ObjectState<string[]>
  data: FirebaseMessageListItem[]
  initialize: boolean
  stateShowOlderButton: ObjectState<boolean>
  stateFilterOlder: ObjectState<MessageFilterOlder>
  stateFinishFetch: ObjectState<boolean>
  onEndReached?(): void
}

export default function GiftShopMessageList({
  stateMode,
  stateSelectedMessagesForkygram,
  stateSelectedMessagesGS,
  stateSelectedMessagesSystem,
  data,
  initialize,
  stateShowOlderButton,
  stateFilterOlder,
  stateFinishFetch,
  onEndReached,
}: GiftShopMessageListProps) {
  const [mode] = stateMode
  return mode === 'new-message' ? (
    <GiftShopMessageListNew />
  ) : (
    <GiftShopMessageListHome
      stateMode={stateMode}
      stateSelectedMessagesForkygram={stateSelectedMessagesForkygram}
      stateSelectedMessagesGS={stateSelectedMessagesGS}
      stateSelectedMessagesSystem={stateSelectedMessagesSystem}
      data={data}
      initialize={initialize}
      stateShowOlderButton={stateShowOlderButton}
      stateFinishFetch={stateFinishFetch}
      stateFilterOlder={stateFilterOlder}
      onEndReached={onEndReached}
    />
  )
}
